import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import PeopleIcon from "@mui/icons-material/People";
import { useMediaQuery } from "@mui/material";
const getStyles = (isIphone, colorStyle) => {
  let styles = {
    backgroundColor: "#84BBD2",
    color: "#000",
    fontSize: isIphone ? 12 : 14,
    height: isIphone ? 28 : 32,
    width: isIphone ? 60 : 80,
    padding: 0,
    "&:hover": {
      // color: "#F0F2F5",
      color: "#000",
      backgroundColor: "#1C82CF",
    },
  };
  return styles;
};

export default function OutSourceButton(props) {
  const theme = useTheme();
  const isIphone = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Button
      component="label"
      variant="contained"
      startIcon={<PeopleIcon sx={{ height: "16px" }} />}
      disabled={props.disabled}
      onClick={(event) => props.onClick(event)}
      sx={getStyles(isIphone, props.colorStyle)}
    >
      {props.label}
      {/* <VisuallyHiddenInput type="file" /> */}
    </Button>
  );
}
